import React from 'react';

import IntegrationsPageContent from 'components/dashboard/integrations/IntegrationsPageContent';

const ShopifyIntegrationPage = () => <IntegrationsPageContent integration="shopify" />;

export default ShopifyIntegrationPage;
